import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Close } from 'components/Shared/Icons/Icons';
import SegmentIO from 'reporting/SegmentIO';

type FrictionlessSignInPhase3CTAProps = {
  email: string;
  onSignInLinkClicked: () => void;
};

const FrictionlessSignInPhase3CTA = ({
  email,
  onSignInLinkClicked,
}: FrictionlessSignInPhase3CTAProps) => {
  const [shouldShowCTA, setShouldShowCTA] = useState(true);
  const handleCancel = () => {
    setShouldShowCTA(false);
    SegmentIO.frictionlessLoginPhase3SignInCTAClosed();
  };

  const handleSignInLink = () => {
    onSignInLinkClicked();
  };

  if (!shouldShowCTA) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="sign-in-phase-iii-cta-wrapper" data-testid="frictionless-signin-cta">
        <div className="sign-in-phase-iii-cta-container">
          <div className="sign-in-phase-iii-cta-body">
            <div className="sign-in-phase-iii-cta-body-message">
              <FormattedMessage
                id="FRICTIONLESS_PHASE_III_SIGN_IN_CTA_TITLE"
                defaultMessage="We found an account for {email}."
                values={{
                  email,
                }}
              />
              <div className="sign-in-phase-iii-cta-body-message-link" onClick={handleSignInLink}>
                <FormattedMessage
                  id="FRICTIONLESS_PHASE_III_SIGN_IN_CTA_LINK"
                  defaultMessage="Sign in with a one-time code"
                />
              </div>
            </div>
            <div
              className="sign-in-phase-iii-cta-body-cancel-btn"
              onClick={handleCancel}
              aria-label="Close Frictionless Sign In CTA"
            >
              <Close />
            </div>
          </div>
        </div>
        <div className="sign-in-phase-iii-cta-body-message-disclaimer">
          <FormattedMessage
            id="FRICTIONLESS_PHASE_III_SIGN_IN_CTA_DISCLAIMER"
            defaultMessage="Standard call or SMS rates may apply."
          />
        </div>
      </div>
      <style jsx>{`
        .sign-in-phase-iii-cta-wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          align-self: stretch;
        }
        .sign-in-phase-iii-cta-container {
          display: flex;
          width: 100%;
          padding: 16px;
          flex-direction: column;
          align-items: flex-start;
          border-radius: 8px;
          border: 1px solid #205ea3;
          background: #f4f9ff;
        }
        .sign-in-phase-iii-cta-body {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
        }
        .sign-in-phase-iii-cta-body-message {
          display: flex;
          flex-direction: column;
          align-self: stretch;
          padding: 2px 0 2px 2px;
          align-items: flex-start;
          flex: 1 0 0;
          color: #21262a;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
        .sign-in-phase-iii-cta-body-message-link {
          color: #0365ac;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
          text-decoration: none;
          cursor: pointer;
        }
        .sign-in-phase-iii-cta-body-message-link:hover {
          text-decoration: underline;
        }
        .sign-in-phase-iii-cta-body-cancel-btn {
          cursor: pointer;
        }
        .sign-in-phase-iii-cta-body-message-disclaimer {
          color: #6b6c72;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
        }
      `}</style>
    </React.Fragment>
  );
};

export default FrictionlessSignInPhase3CTA;
